import { useContext } from "react"
import { NewsContext, PageContext } from "../../App"
import MainHeader from "../../layouts/MainHeader"
import Footer from "../../layouts/Footer"
import pagesNames from "../../constants/pages-names"
import ArrowRight from '../../assets/icons/arrow-right.svg';


const NewsHeader = () => {
    const { currentNewsData } = useContext(NewsContext);
    const { handleChangePage } = useContext(PageContext);

  return (
    <div className="sticky-view-two">
        <div className="sticky-container">
            <MainHeader 
                image={{
                    src : require(`../../assets/images/news/${currentNewsData.image.name}`),
                    alt : currentNewsData.image.alt,
                }}
                title=""
            />
        </div>
        <div className="sticky-container-two" id="mainContent">
            <div className="wrapper-small">
                <button 
                    type="button"
                    className="back-button"
                    title="back to news page"
                    aria-label="back to news page"
                    onClick={() => {
                        handleChangePage(pagesNames.news)
                    }}
                >
                    <span>
                        <img src={ArrowRight} alt="" aria-hidden="true" />
                    </span>
                    <span>Back</span>
                </button>
                <h1 className="title-center">{currentNewsData.title}</h1>
                {/* <p className="text-paragraph">{currentNewsData.shortDescription}</p> */}
                <div className="content">
                    {currentNewsData.content}
                </div>
            </div>
            <Footer withBlogs={false} />
        </div>
    </div>
    
  )
}

export default NewsHeader